import React from 'react';

import { Box, Button, Typography } from '@explorer/core';
import EditIcon from '@mui/icons-material/Edit';
import { useIntl } from 'react-intl';

import { Stack, useDialog } from '@crucible-risk/security-applications';

import { EscalationContactsModal } from './EscalationContactsModal';
import { useQueryEscalationContacts } from './useQueryEscalationContacts';

interface EscalationContactsProps {
  clientId: string;
}

export const EscalationContacts = ({ clientId }: EscalationContactsProps) => {
  const intl = useIntl();
  const { openDialog, closeDialog, open } = useDialog();

  const { data: contactsData, isLoading } = useQueryEscalationContacts({
    client_id: clientId,
  });

  const contacts = contactsData?.contacts || [];

  return (
    <Stack spacing={2} sx={{ mt: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">
          {intl.formatMessage({ id: 'mdr.escalation-contacts.title' })}
        </Typography>
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={openDialog}
          disabled={isLoading}
        >
          {intl.formatMessage({ id: 'mdr.escalation-contacts.edit-button' })}
        </Button>
      </Box>

      <EscalationContactsModal
        clientId={clientId}
        open={open}
        closeDialog={closeDialog}
        contacts={contacts}
      />
    </Stack>
  );
};
